import styles from "./ProductAddonGroups.module.scss";
import ProductConfigurationSection from "./ProductConfigurationSection";
import CheckBoxTypeAddonGroup from "../form/CheckBoxTypeAddonGroup";
import RadioButtonTypeAddonGroup from "../form/RadioButtonTypeAddonGroup";
import QuantityModifierAddonGroup from "../form/QuantityModifierAddonGroupForm";

export default function ProductAddonGroups() {
  return (
    <div className={styles.container}>
      <ProductConfigurationSection
        title="Checkbox Type Addon Group"
        subtitle="You'll get 2 free add-on(s)"
        additionalInfo={"Mandatory choice"}
        hasError
      >
        <CheckBoxTypeAddonGroup />
      </ProductConfigurationSection>

      <ProductConfigurationSection
        title="Radio Button Type Addon Group"
        subtitle="Select maximum of 2 add-on(s)"
        additionalInfo={"Mandatory choice"}
        hasError
      >
        <RadioButtonTypeAddonGroup />
      </ProductConfigurationSection>

      <ProductConfigurationSection
        title="Quantity Modifier Addon Group"
        subtitle="Select at least 2 add-on(s)"
        additionalInfo={"Mandatory choice"}
        hasError
      >
        <QuantityModifierAddonGroup />
      </ProductConfigurationSection>
    </div>
  );
}
